import { PreVettingStep3Screen } from "@/features/vendor/pre-vetting";

export default PreVettingStep3Screen;
